import { Box } from "@chakra-ui/react";

import { colors, getCdnImageSrc, HLine, HStack, Image, VStack, Starring } from "goi_common";
import { useRecoilValue } from "recoil";
import { reviewStarsState } from "../../../../atoms/funeralReviewState";

function ReviewDoneSection({ id }: { id: string }) {
  const star = useRecoilValue(reviewStarsState);
  return (
    <Box>
      <HStack padding="36px 26px 40px">
        <VStack width="60px" css={{ borderRadius: "50%", overflow: "hidden" }}>
          <Image
            alt="상조 이미지"
            src={getCdnImageSrc(`platform/sangjos/${id}/logo.png`)}
            width={50}
          />
        </VStack>
        <VStack gap="9.5px" css={{ paddingTop: "3px" }}>
          <Starring star={star} gap="3px" size="22px" />
          <Box className="body2" color={colors.gray600} pl="2px">
            평가를 완료하셨습니다.
          </Box>
        </VStack>
      </HStack>
      <HLine width="100%" color={colors.gray100} />
      <Box padding="60px 30px" width="100%" textAlign="center">
        <Box className="subtitle2_sb gray900" margin="auto">
          소중한 후기를 남겨주셔서 감사합니다.
        </Box>
        <Box className="body2 gray700" margin="auto" pt="8px">
          고이가 온전히 고인을 추모하고
          <br />
          가족들이 위로받으시는 데<br />
          충분한 도움을 드렸길 바랍니다.
        </Box>
      </Box>
    </Box>
  );
}

export default ReviewDoneSection;
